import React from "react";

import styles from "./styles.module.scss";
import { images } from "../../../core/constants/images";
import { Text } from "../../../core/constants/strings";

const FooterTablet = () => {
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${images.footerBackground})` }}>
      <div className={styles.content}>
        <div className={styles.column1}>
          <img className={styles.image1} src={images.footerImageOne} />
          <img className={styles.image3} src={images.footerImageThree} />
        </div>
        <div className={styles.column2}>
          <div className={styles.title}>{Text.footer.title}</div>
          <img className={styles.image2} src={images.footerImageTwo} />
          <div className={styles.logoContent}>
            <div className={styles.logoTitle}>{Text.footer.appName}</div>
            <img className={styles.logoImage} src={images.logoNMCP} />
          </div>
        </div>
      </div>
      <div className={styles.lower}>
        <div className={styles.navi}>
          <img className={styles.icon} src={images.worldImage} />
          <div className={styles.naviText}>{Text.footer.webSite}</div>
        </div>
        <div className={styles.navi}>
          <img className={styles.icon} src={images.phoneImage} />
          <div className={styles.naviText}>{Text.footer.phoneNumber}</div>
        </div>
        <div className={styles.navi}>
          <img className={styles.icon} src={images.mailImage} />
          <div className={styles.naviText}>{Text.footer.eMail}</div>
        </div>
      </div>
    </div>
  );
};

export default FooterTablet;
